import { render, staticRenderFns } from "./ui-radiocards.vue?vue&type=template&id=06ecc5ea&"
import script from "./ui-radiocards.vue?vue&type=script&lang=js&"
export * from "./ui-radiocards.vue?vue&type=script&lang=js&"
import style0 from "./ui-radiocards.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06ecc5ea')) {
      api.createRecord('06ecc5ea', component.options)
    } else {
      api.reload('06ecc5ea', component.options)
    }
    module.hot.accept("./ui-radiocards.vue?vue&type=template&id=06ecc5ea&", function () {
      api.rerender('06ecc5ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/kit/ui-radiocards/ui-radiocards.vue"
export default component.exports